import { render } from "./DemoSkeleton.vue?vue&type=template&id=12bdec58"
import script from "./DemoSkeleton.vue?vue&type=script&lang=js"
export * from "./DemoSkeleton.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__